import { enhancedFetch, ssrBuilder } from 'journey-ui'
import { NextPageContext } from 'next'
import React from 'react'
import { AppPage } from '../components/AppPage'
import { BrandHeader } from '../components/BrandHeader'
import { redirectIfNoBrand } from '../helpers'

type Props = {
  brand: Brand
}

const ReturnsPage: React.FC<Props> = ({ brand }) => (
  <AppPage brand={brand} title="Returns" description="Please review our return and refunds policy." fullScreen>
    <BrandHeader className="h-40">
      <span className="z-20">Return Policy</span>
    </BrandHeader>

    {!brand.has_return_policy ? (
      <div className="p-2">
        <h2>Return Policy</h2>
        <p>All sales are final. Please call our location if you have any issues. Thank you!</p>
      </div>
    ) : (
      <div className="p-2">
        <p>Thank you for dining at our restaurant! We always want our customers to be happy.</p>

        <h2 className="py-2">Exchanges & Returns</h2>
        <p>If you're unsatisfied with your meal, we're here to help! Call us and we'll make sure you're taken care of.</p>

        {brand.is_food_required_for_return && (
        <>
          <h2 className="py-2">Limitations</h2>
          <p>The only limitation is that the meal must be returned. We do this for two reasons:</p>
          <br />

          <p>
            1. We want to check and make sure everything was cooked to perfection. If any of our chefs made a mistake, we want to make sure it doesn't happen again.
          </p>

          <br />
          <p>
            2. We want to make sure our awesome return policy isn't being exploited.
            Obviously if someone finishes eating a whole pizza, it isn't fair to refund the purchase or ask for a replacement.
            To keep our prices low and our quality high, we just ask that if there's a problem with your order
            , you let us know right away so that we can make it right and everyone is happy.
          </p>
        </>
        )}

        <p>Thank you!</p>
      </div>
    )}
  </AppPage>
)

// noinspection JSUnusedGlobalSymbols (PHPStorm doesn't detect NextJS's pages)
export default ReturnsPage

export async function getServerSideProps(ctx) {
  return ssrBuilder(ctx)
    .setProp('brand', (fetcher) => fetcher(`/api/brand/${ctx.req.headers.host}`))
    .onError(redirectIfNoBrand)
    .get()
}
